import Vue from 'vue'
import Router from 'vue-router'
import WIT from '@/pages/intelligentWirelessSolution/index.vue'

Vue.use(Router)

export const constantRouterMap = [
  { path: '/', component: WIT }
]

export default new Router({
  scrollBehavior: () => ({ y: 0 }), // 当切换到新路由时，页面滚到顶部
  routes: constantRouterMap
})

/* export default new Router({
  scrollBehavior: () => ({ y: 0 }), // 当切换到新路由时，页面滚到顶部
  routes: [
    {
      path: '/',
      name: 'WIT',
      component: WIT
    }
  ]
}) */



// WEBPACK FOOTER //
// ./src/router/index.js